import { isLocalDevOrStg } from "@util/constant";

export const smxPrebidScript = isLocalDevOrStg
  ? "https://adtag.sphdigital.com/tag/smx/sandbox/smx_prebid.js"
  : "https://adtag.sphdigital.com/tag/smx/smx_prebid.js";
